import React from "react";
import Carousel from "better-react-carousel";

function Whoweare() {
  return (
    <div className="PrimaryB py-14 lg:py-14  md:py-14  sm:py-14  xs:py-14  px-16 md:px-16 sm:px-4 xs:px-4  grid gap-4 grid-cols-2  lg:grid-cols-2  md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1   ">
    <div className=" Transition  w-[90%] sm:py-8 xs:py-8 flex md:flex sm:hidden xs:hidden justify-center items-center flex-row md:flex-row sm:flex-col xs:flex-col gap-4 ">
      <Carousel
        cols={3}
        rows={2}
        gap={20}
        autoplay={3000}
        hideArrow="true"
        loop="true"
       
      >
        <Carousel.Item>
            <img
              className="rounded-full darkshadow  cover  h-28 w-28"
              src="data:image/png;base64,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"
              alt=""
            />
            
        </Carousel.Item>
        <Carousel.Item>
            <img
              className="rounded-full  cover  darkshadow h-28 w-28"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPgSErd7wC0J0S4dHgiAOB2i9ia82BlmOxS0r5enyKoYMpz_lwt0HcGZ4KDgS1apmV-90&usqp=CAU"
              alt=""
            />
          
        </Carousel.Item>
        <Carousel.Item>
            <img
              className="rounded-full  cover  darkshadow h-28 w-28"
              src="https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcQht-xfe7V960iPhkC_xy0JPXTdoX3reuY_ieNGqnBE-bqlfJOx"
              alt=""
            />
        </Carousel.Item>
        <Carousel.Item>
            <img
              className="rounded-full  cover  darkshadow h-28 w-28"
              src="https://kgo.googleusercontent.com/profile_vrt_raw_bytes_1587515371_10627.jpg"
              alt=""
            />
         
        </Carousel.Item>
        <Carousel.Item>
            <img
              className="rounded-full  cover  darkshadow h-28 w-28"
              src="https://www.insightplatforms.com/wp-content/uploads/2021/03/Google-Trends-Logo-Square-Insight-Platforms.png"
              alt=""
            />
        </Carousel.Item>
        <Carousel.Item>
            <img
              className="rounded-full  cover  darkshadow h-28 w-28"
              src="https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcSjm7QVNRMUvMePGW50DbxSX9kTfTxmWh9hg_NY55HtWjOXnhCF"
              alt=""
            />
         
        </Carousel.Item>
      </Carousel>
    </div>
    <div className=" w-full  mt-8 p-0 md:p-0 sm:p-0 xs:p-0">
        <h3 className=" text-white text-5xl md:text-5xl sm:text-4xl xs:text-4xl font-black  text-left md:text-left sm:text-left xs:text-left mb-4">
         Our Seo
        </h3>
        <hr className="w-[100%] md:w-[100%] sm:w-[100%] xs:w-[100%] weight-900 secondary " />

        <p className="text-lg mt-4 md:mt-4 sm:mt-0 xs:mt-0 text-white text-left">
          Welcome to search engine optimization page. Drive
          organic traffic, increase your online visibility, and grow your
          business with our expert SEO services. At Fnevol, we
          specialize in delivering top-notch search engine optimization
          strategies that will boost your website's rankings and ensure maximum
          online exposure.
        </p>
      </div>
    </div>
  );
}

export default Whoweare;
